<template>
  
    <div >
      <nmsdashboard></nmsdashboard>
      <onedevicepolicy ></onedevicepolicy>
      <!-- <twodevicepolicy v-else-if="!$store.state.currentOrg.org.isPrimaryOrganisation&&!$store.state.currentOrg.org.primaryOrganisation.oneDevicePolicy"></twodevicepolicy> -->
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import oneDevicePolicyDashboard from './ISPDashboardOneDevice';
import twoDevicePolicyDashboard from './ISPDashboardTwoDevice';
import NmsDashboard from '@/components/NmsDashboard.vue';

export default {
  components: {
    onedevicepolicy: oneDevicePolicyDashboard,
    twodevicepolicy: twoDevicePolicyDashboard,
    nmsdashboard: NmsDashboard
  }
};
</script>